import { UserSchema } from "@/schemas/user.schema";
import { cbHttp } from "./http.service";
import { z } from "zod";
import { UserFormSchema } from "@/schemas/user-form.schema";


export const getAllUsers = async (): Promise<z.infer<typeof UserSchema>[]> => {
    return cbHttp.get('/api/users');
}

export const addUser = async (data: z.infer<typeof UserFormSchema>): Promise<z.infer<typeof UserSchema>> => {
    return cbHttp.post('/api/users', data);
}